import React from "react"

function Logo(props) {
    const { title = "Climate ai" } = props
    return (
        <>
            <p className="w-auto h-[26px] flex justify-center items-center text-[18px] text-gray-60 font-semibold">
                {title && typeof title === "string" && title}
            </p>
        </>
    )
}

export default Logo
